import { ContinueWithGoogle } from '../../components/ContinueWithGoogle'
import { FormEvent, useEffect, useState } from 'react'
import { Input, preventSpaceInput } from '../../components/FormElements/Input'
import { useTranslation } from 'react-i18next'
import { useWhoAmI } from '../../hooks/queries/useWhoAmI'
import { persistUrlParameters, getUrlParameters } from '../../helpers/urls'
import { setNewAccessToken } from '../../infrastructure/apis'
import { useNavigate } from 'react-router-dom'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

export const LoginMethods = () => {
    const navigate = useNavigate()
    const { t } = useTranslation('signIn')
    const { executeRecaptcha } = useGoogleReCaptcha()
    const [email, setEmail] = useState('')
    const [error, setError] = useState<string>()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const onError = (error: any) => setError(error?.response?.data?.message ?? error?.message)

    useEffect(() => {
        persistUrlParameters()

        const { token, courseId } = getUrlParameters()

        if (!token) return

        setNewAccessToken(token as string)
        navigate(courseId ? `/dashboard/${courseId}` : '/')

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const { refetch, isFetching, captchaTokenRef } = useWhoAmI({
        email,
        onError,
    })

    const onSubmit = async (event?: FormEvent<HTMLFormElement>) => {
        event?.preventDefault()
        setError(undefined)
        if (!executeRecaptcha) {
            setError('captchaNotReady')
            return
        }
        setIsSubmitting(true)
        try {
            captchaTokenRef.current = await executeRecaptcha('useWhoAmI')
        } catch (error) {
            onError(error)
            setIsSubmitting(false)
            return
        }
        await refetch()
        setIsSubmitting(false)
    }

    return (
        <>
            <h1 className="title">{t('Log in')}</h1>

            <ContinueWithGoogle />

            <form onSubmit={onSubmit}>
                <Input
                    {...{
                        id: 'email',
                        name: 'email',
                        label: t('Email'),
                        autoComplete: 'username',
                        type: 'email',
                        placeholder: 'username@mail.com',
                        required: true,
                        disabled: isFetching || isSubmitting,
                        value: email ?? '',
                        onChange: ({ target: { value } }) => {
                            setError(undefined)
                            setEmail(value.trim())
                        },
                        onKeyDown: preventSpaceInput,
                        error: error ? t(error) : undefined,
                    }}
                />
                <br />
                <button className="primary w-100" children={t('Log in')} disabled={!email || isFetching || isSubmitting} />
            </form>

            <br />
        </>
    )
}

export default LoginMethods
